import axiosClient from "@/utils/axios-client";
import {
  PathPickBasketCountsResponse,
  PathPickNaverPartnerAddressBooksResponse,
  PathPickNaverPartnerStatusResponse,
  PathPickSmartStoreInfoResponse,
} from "@/features/pathpick/features/basket/types/response";
import { PathPickFilterInfoResponse } from "@/features/pathpick/types/response";

const url = {
  smartStoreInfos: (companyId: number) =>
    `/buyers/${companyId}/smart-store-infos`,
  getNaverPartnerStatus: (companyId: number) =>
    `/pathpick/naver_partner/buyers/${companyId}/status`,
  getNaverPartnerAddressBooks: (companyId: number) =>
    `/pathpick/naver_partner/buyers/${companyId}/address-books`,
  getPathPickBasketFilterInfo: (companyId: number) =>
    `/buyers/${companyId}/pathpick/basket/filter-info`,
  getPathPickBasketCounts: (companyId: number) =>
    `/buyers/${companyId}/pathpick/basket/counts`,
};

export const pathPickBasketQueryApi = {
  // 스마트스토어 상품 등록 기본 정보 조회
  getSmartStoreInfo: async (companyId: number) => {
    const { data } = await axiosClient.get<PathPickSmartStoreInfoResponse>(
      url.smartStoreInfos(companyId)
    );
    return data;
  },
  // 네이버 제휴(판매자ID) 연결 상태 조회
  getNaverPartnerStatus: async (companyId: number) => {
    const { data } = await axiosClient.get<PathPickNaverPartnerStatusResponse>(
      url.getNaverPartnerStatus(companyId)
    );
    return data;
  },
  // 네이버 제휴 판매자 주소록 조회 — 해외 출고지 판정에만 쓰므로 주소 종류로 좁혀 받는다.
  // 바이어가 해외 출고지를 "일반"(GENERAL)으로 등록하는 경우가 있어 출고지(RELEASE)와 함께 받는다.
  getNaverPartnerAddressBooks: async (companyId: number) => {
    const { data } =
      await axiosClient.get<PathPickNaverPartnerAddressBooksResponse>(
        url.getNaverPartnerAddressBooks(companyId),
        { params: { type__in: ["RELEASE", "GENERAL"] } }
      );
    return data;
  },
  // 담은 상품 필터 정보 — 이 바이어가 담은 상품에서만 뽑은 브랜드/카테고리
  getPathPickBasketFilterInfo: async (companyId: number) => {
    const { data } = await axiosClient.get<PathPickFilterInfoResponse>(
      url.getPathPickBasketFilterInfo(companyId)
    );
    return data;
  },
  // 담은 상품 탭 카운트 — 작업 전/등록 신청함/주문함.
  // 파라미터가 없어 탭·검색·필터와 무관하게 담은 상품 전체 기준으로 센다.
  getPathPickBasketCounts: async (companyId: number) => {
    const { data } = await axiosClient.get<PathPickBasketCountsResponse>(
      url.getPathPickBasketCounts(companyId)
    );
    return data;
  },
};
